import PropTypes from 'prop-types'
import React from "react"
import { Link } from "react-router-dom"
import { map } from "lodash"
import {
  Card,
  CardBody,
  Col,
  Media,
} from "reactstrap"

import logoLightPng from "assets/images/birthchartlogo.png"
import * as moment from 'moment'
import { isEmpty } from 'lodash'
import { ROUTER_GROUP } from "helpers/router_helper"

const ReportCard = ({ birthChartList, handleDownload }) => {
  const birth_card_strong_style = {
    fontFamily: "Helvetica Neue,Helvetica,Arial,sans-serif",
    boxSizing: "border-box",
    fontSize: "14px",
    margin: "0",
  }
  const birth_card_span_style = {
    backgroundColor: "#20c5c9",
    color: "#ffffff",
    padding: "3px 5px",
    fontSize: "12px",
    borderRadius: "4px",
  }
  console.log("birthChartList, ", birthChartList)
  return (
    <React.Fragment>
      {map(birthChartList, (birthChart, dkey) => (
        <Col xl="6" sm="6" key={"__projectcd_" + dkey}>
          <Card>
            <CardBody>
              <Media>
                <div className="avatar-md me-4">
                    <img src={logoLightPng} alt="" className="img-thumbnail rounded-circle"/>
                </div>

                <Media className="overflow-hidden" body>
                  <h5 className="text-truncate font-size-15">
                    <Link
                      to={`${ROUTER_GROUP}/report-summary/${birthChart.birthInputId}`}
                      className="text-dark"
                    >
                      {isEmpty(birthChart.lastName) ? (birthChart.firstName)
                        : (birthChart.firstName + " " + birthChart.lastName)}
                    </Link>
                  </h5>

                  <ul className="text-muted list-inline mb-2">
                    <li className="list-inline-item me-0" id="dueDate">
                      <i className="bx bx-cake me-0" /> {birthChart.dateOfBirth}
                    </li>{" "}
                    <li className="list-inline-item me-0" id="comments">
                      <i className="bx bx-time me-0" />{" "}
                      {birthChart.timeOfBirth}
                    </li>
                  </ul>

                  <h5 className="text-truncate font-size-15 text-success mb-2">
                    Rasi : {birthChart.chandraRasi} , Nakshatra : {birthChart.nakshatra}
                  </h5>
                </Media>
              </Media>
            </CardBody>
            <div className="px-3 py-3 border-top">
              <ul className="list-inline mb-0">
                <li className="text-muted list-inline-item me-3" id="createdDate">
                  <i className="bx bx-calendar me-2" />{moment(new Date(birthChart.createdDate)).format("DD-MM-YYYY hh:mm:ss a")}
                  {console.log(birthChart.createdDate)}
                </li>
                <li className="list-inline-item me-2" id="view">
                  <Link to={`${ROUTER_GROUP}/report-summary/${birthChart.birthInputId}`}>
                    <strong style={birth_card_strong_style}>
                      <span style={birth_card_span_style}>
                        View
                      </span>
                    </strong>
                  </Link>
                </li>
                <li className="list-inline-item me-0" id="download">
                  <Link to="#" onClick={() => {
                    isEmpty(birthChart.lastName) ? handleDownload(birthChart.birthInputId, birthChart.firstName) : handleDownload(birthChart.birthInputId, birthChart.firstName + " " + birthChart.lastName)
                  }}>
                    <strong style={birth_card_strong_style}>
                      <span style={birth_card_span_style}>
                        Download
                      </span>
                    </strong>
                  </Link>
                </li>
              </ul>
            </div>
          </Card>
        </Col>
      ))
      }
    </React.Fragment >
  )
}

ReportCard.propTypes = {
  birthChartList: PropTypes.array
}

export default ReportCard